import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Button, Menu, MenuItem} from '@material-ui/core';
import {ArrowDropDown as ArrowDropDownIcon, ArrowDropUp as ArrowDropUpIcon} from '@material-ui/icons';
import {isEmpty} from 'lodash/lang';

const DropDownMenu = ({
  component: Component,
  buttonText,
  buttonProps,
  items,
  onSelect,
  labelKey,
  valueKey,
  hasCaret,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const hasOptions = !isEmpty(items) && items.length > 0;

  const _handleMenuOpen = ({currentTarget}) => {
    if (hasOptions) {
      setAnchorEl(currentTarget);
    }
  };

  const _handleClose = () => setAnchorEl(null);

  const _handleSelect = (value) => {
    onSelect(value);
    _handleClose();
  };

  const open = !!anchorEl;
  return (
    <div>
      <Component {...buttonProps} onClick={_handleMenuOpen}>
        {buttonText}
        {hasCaret &&
          hasOptions &&
          React.createElement(open ? ArrowDropUpIcon : ArrowDropDownIcon, {className: 'small-margin'})}
      </Component>
      <Menu anchorEl={anchorEl} keepMounted open={open} onClose={_handleClose}>
        {items.map((item) => (
          <MenuItem key={item[valueKey]} onClick={() => _handleSelect(item[valueKey])}>
            {item[labelKey]}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

DropDownMenu.propTypes = {
  component: PropTypes.any.isRequired,
  buttonText: PropTypes.node.isRequired,
  buttonProps: PropTypes.object.isRequired,
  items: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
  labelKey: PropTypes.string.isRequired,
  valueKey: PropTypes.string.isRequired,
  hasCaret: PropTypes.bool.isRequired,
};

DropDownMenu.defaultProps = {
  component: Button,
  buttonProps: {},
  labelKey: 'label',
  valueKey: 'value',
  hasCaret: true,
};

export default DropDownMenu;
